export default __webpack_public_path__ + "static/COL-USA_SERVICES-c6c1a1a8895f81cf97d3f12055f3d528.pdf";